import { useEffect } from 'react'
import type { ReactNode } from 'react'

export function AspectFrame({ children }: { children: ReactNode }) {
  useEffect(() => {
    const apply = () => {
      const vw = window.innerWidth
      const vh = window.innerHeight
      const w = Math.min(vw, (vh * 16) / 9)
      const h = Math.min(vh, (vw * 9) / 16)
      const scale = w / 1920
      const root = document.documentElement
      root.style.setProperty('--scale', scale.toFixed(4))
      root.style.setProperty('--aspect-w', `${w.toFixed(2)}px`)
      root.style.setProperty('--aspect-h', `${h.toFixed(2)}px`)
    }
    apply()
    window.addEventListener('resize', apply)
    return () => window.removeEventListener('resize', apply)
  }, [])

  return (
    // Dashboard je zamčený na 16:9, takže na jiném poměru stran zbydou po
    // stranách pruhy. Místo tvrdé černé je vyplníme podkladem dashboardu
    // s jemným nádechem značky, aby to působilo jako rám, ne jako chyba.
    <div
      className="grid h-screen w-screen place-items-center overflow-hidden"
      style={{
        background:
          'radial-gradient(130% 100% at 50% 0%, color-mix(in srgb, var(--brand-primary) 10%, var(--surface-0)) 0%, var(--surface-0) 60%)',
      }}
    >
      <div
        className="relative overflow-hidden rounded-[4px] shadow-[0_0_80px_rgba(0,0,0,0.55)]"
        style={{ width: 'var(--aspect-w, 100vw)', height: 'var(--aspect-h, 100vh)' }}
      >
        {children}
      </div>
    </div>
  )
}
